<template>
  <article class="home">
    <app-navbar></app-navbar>
    <section class="home__container">
      <app-slider></app-slider>
      <app-us></app-us>
      <app-products-and-services></app-products-and-services>
      <app-experience></app-experience>
      <app-clients></app-clients>
      <app-human-talent></app-human-talent>
    </section>
  </article>
</template>

<script>
export default {
  methods:{
  },
  mounted(){
  },
  data(){
    return{
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue